var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "40px",
    viewBox: "0 0 37 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A6A9B4C-37CB-4E37-ADD8-56AC1A2F5974") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart\\xE3o",
    transform: "translate(-1074.000000, -150.000000)",
    fill: "#E71037",
    stroke: "#E71037",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-paper",
    transform: "translate(1075.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8823529,38 L11.1176471,38 C8.848,38 7,36.0943 7,33.75 L7,8.25 C7,5.9057 8.848,4 11.1176471,4 L30.8823529,4 C33.152,4 35,5.9057 35,8.25 L35,33.75 C35,36.0943 33.152,38 30.8823529,38 Z M11.1176471,5.7 C9.75552941,5.7 8.64705882,6.8441 8.64705882,8.25 L8.64705882,33.75 C8.64705882,35.1559 9.75552941,36.3 11.1176471,36.3 L30.8823529,36.3 C32.2444706,36.3 33.3529412,35.1559 33.3529412,33.75 L33.3529412,8.25 C33.3529412,6.8441 32.2444706,5.7 30.8823529,5.7 L11.1176471,5.7 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76470588,35 L4.11764706,35 C1.848,35 0,33.1316667 0,30.8333333 L0,4.16666667 C0,1.86833333 1.848,0 4.11764706,0 L23.8823529,0 C26.152,0 28,1.86833333 28,4.16666667 C28,4.62666667 27.6310588,5 27.1764706,5 C26.7218824,5 26.3529412,4.62666667 26.3529412,4.16666667 C26.3529412,2.78833333 25.2444706,1.66666667 23.8823529,1.66666667 L4.11764706,1.66666667 C2.75552941,1.66666667 1.64705882,2.78833333 1.64705882,4.16666667 L1.64705882,30.8333333 C1.64705882,32.2116667 2.75552941,33.3333333 4.11764706,33.3333333 L5.76470588,33.3333333 C6.21929412,33.3333333 6.58823529,33.7066667 6.58823529,34.1666667 C6.58823529,34.6266667 6.21929412,35 5.76470588,35 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2222222,27 L13.7777778,27 C13.3484444,27 13,26.552 13,26 C13,25.448 13.3484444,25 13.7777778,25 L26.2222222,25 C26.6515556,25 27,25.448 27,26 C27,26.552 26.6515556,27 26.2222222,27 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2222222,33 L13.7777778,33 C13.3484444,33 13,32.552 13,32 C13,31.448 13.3484444,31 13.7777778,31 L26.2222222,31 C26.6515556,31 27,31.448 27,32 C27,32.552 26.6515556,33 26.2222222,33 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2222222,20 L13.7777778,20 C13.3484444,20 13,19.552 13,19 C13,18.448 13.3484444,18 13.7777778,18 L26.2222222,18 C26.6515556,18 27,18.448 27,19 C27,19.552 26.6515556,20 26.2222222,20 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2222222,13 L13.7777778,13 C13.3484444,13 13,12.552 13,12 C13,11.448 13.3484444,11 13.7777778,11 L26.2222222,11 C26.6515556,11 27,11.448 27,12 C27,12.552 26.6515556,13 26.2222222,13 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperOrange);
export default __webpack_public_path__ + "static/media/paper-orange.05bc91f75fb6016f3e9284225d69c273.svg";
export { ForwardRef as ReactComponent };